import { useCallback, useEffect, useRef } from 'react';
export var useClickOutside = function (_a) {
    var onClose = _a.onClose, parentRef = _a.parentRef, _b = _a.ignoreClickOutside, ignoreClickOutside = _b === void 0 ? false : _b, _c = _a.closeCurrent, closeCurrent = _c === void 0 ? false : _c, _d = _a.allowScrollbarClick, allowScrollbarClick = _d === void 0 ? false : _d;
    var elementRef = useRef(null);
    var onCloseModal = !ignoreClickOutside ? onClose : undefined;
    var handleClickOutside = useCallback(function (e) {
        var _a;
        var ignoreEvent = allowScrollbarClick && e.offsetX > e.target.clientWidth;
        if (!ignoreEvent &&
            elementRef.current &&
            !elementRef.current.contains(e.target) &&
            !((_a = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            closeCurrent ? e.target.contains(elementRef.current) && (onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal()) : onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
        }
    }, [allowScrollbarClick, parentRef, closeCurrent, onCloseModal]);
    var keyPress = useCallback(function (e) {
        if (e.key === 'Escape') {
            onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
        }
    }, [onCloseModal]);
    useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', keyPress);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', keyPress);
        };
    }, [handleClickOutside, keyPress]);
    return elementRef;
};
